import { UserAction, UserActionType } from '../actions/user';
import { updateDatadogRumUser } from '../initDatadogRUM';
import { UserNamespace } from '../state/user';

export const userReducer = (
    state: UserNamespace = {
        userInstruments: [],
        hasPassword: false,
        hasSocialLogin: false,
        isInitiallyLoggedInUser: false,
        loginWindowPopUpInstance: null,
    },
    action: UserAction,
): UserNamespace => {
    switch (action.type) {
        case UserActionType.initializeUser:
            updateDatadogRumUser(action.payload);

            return {
                ...state,
                ...(action.payload ?? {}),
                ...(action.payload
                    ? { isInitiallyLoggedInUser: !!action.payload?.publicId }
                    : {}),
            };
        case UserActionType.updateUserInstruments:
            return {
                ...state,
                userInstruments: action.payload,
            };

        case UserActionType.setVirtualIncentive:
            return {
                ...state,
                virtualIncentive: action.payload,
            };

        case UserActionType.setUserAsLoggedIn:
            updateDatadogRumUser(action.payload);

            return {
                ...state,
                ...action.payload,
            };
        case UserActionType.setUserSiginInMethods:
            return {
                ...state,
                ...action.payload,
            };
        case UserActionType.clearUserData:
            updateDatadogRumUser({});

            return {
                userInstruments: [],
                hasPassword: false,
                hasSocialLogin: false,
                isInitiallyLoggedInUser: false,
                loginWindowPopUpInstance: null,
            };

        case UserActionType.setLoginFromCheckoutPage:
            return {
                ...state,
                loginFromCheckoutPage: action.payload,
            };

        case UserActionType.setLoginWindowPopUpInstance:
            return {
                ...state,
                loginWindowPopUpInstance: action.payload,
            };

        default:
            return state;
    }
};
